<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="store/warehouse/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { Warehouse } from '@/modules/store/data/warehouse/create'
	import { WarehouseService } from '@/modules/store/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return Warehouse;
			},

			service()
			{
				return new WarehouseService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>